module.exports = __webpack_public_path__ + "static/media/addImage.65b6a0a1.svg";